var React = require('react');

function DownChevron (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M17.167 8.266 9.81.838a1.14 1.14 0 0 0-1.621 0L.834 8.266a1.154 1.154 0 0 0 0 1.622l.1.09c.45.36 1.105.33 1.52-.09L9 3.463l6.552 6.431a1.138 1.138 0 0 0 1.616-.004 1.153 1.153 0 0 0 0-1.623Z","fillRule":"nonzero"}));
}

DownChevron.defaultProps = {"viewBox":"0 0 18 11"};

module.exports = DownChevron;

DownChevron.default = DownChevron;
